
import isArray from 'lodash/isArray';

export default function processValueWithValues(value, values) {
    if (isArray(values)) {
        values.forEach(item => {
            if (isArray(item) && (item.length > 1) && (value == item[0])) {
                value = item[1];
            }
        });
    }
    return value;
}

